import {Pipe, PipeTransform} from '@angular/core';
@Pipe({
    name: 'currencyFormatPipe'
})
export class CurrencyFormatPipe implements PipeTransform {
    transform (value: any): any {
      if (!value) return value;
      const removeComma = value.toString().replace(/,/g, '')
      if (!removeComma) return value;
      // if (isNaN(Number(value))) return '0';
      let replacedCurrency;
      if(removeComma.indexOf('.') > -1 && removeComma.split('.')[1].length > 2) {
        replacedCurrency = Number(removeComma).toFixed(2);
      } else {
        replacedCurrency = removeComma;
      }
      return String(replacedCurrency).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/currency-format-pipe.ts